/**
 * Full-screen DocuSign view inside the portal — used for the Correct view
 * (swap documents / move fields on an in-flight envelope) and for resuming a
 * draft's tagging screen. Mirrors the Onboarding Centre tagging dialog.
 */
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileSignature, XCircle, CheckCircle } from "lucide-react";

export const EnvelopeIframeDialog = ({ open, url, title, hint, envelope, onClose, onDone }) => (
  <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogContent className="max-w-[95vw] w-[95vw] max-h-[95vh] h-[95vh] p-0" aria-describedby={undefined} data-testid="envelope-iframe-dialog">
      <div className="flex flex-col h-full">
        <div className="flex items-center justify-between p-4 border-b bg-blue-50">
          <div className="flex items-center gap-3 min-w-0">
            <FileSignature className="w-6 h-6 text-blue-600 shrink-0" />
            <div className="min-w-0">
              <h3 className="font-semibold text-blue-900 truncate">{title}</h3>
              <p className="text-sm text-blue-700 truncate">{hint}</p>
            </div>
          </div>
          <Button variant="outline" size="sm" onClick={onClose} className="mr-8" data-testid="envelope-iframe-close">
            <XCircle className="w-4 h-4 mr-1" /> Close
          </Button>
        </div>
        <div className="flex-1 bg-gray-100">
          {url && <iframe src={url} className="w-full h-full border-0" title={title} allow="camera; microphone" />}
        </div>
        <div className="p-3 border-t bg-gray-50 flex items-center justify-between">
          <p className="text-xs text-muted-foreground truncate">
            {envelope?.subject} · <span className="font-mono">{envelope?.envelope_id}</span>
          </p>
          <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700 text-white" onClick={onDone} data-testid="envelope-iframe-done">
            <CheckCircle className="w-4 h-4 mr-1" /> I&apos;m done in DocuSign
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
